import PropTypes from 'prop-types';
import Link from '@/components/Link';
import TertiaryTitle from '@/components/TertiaryTitle';
import Text from '@/components/Text';
import clsx from 'clsx';

const defaultProps = {};

const propTypes = {
  url: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  icon: PropTypes.node.isRequired,
};

export default function SectionContactLink({ url, title, description, icon }) {
  return (
    <Link
      href={url}
      className="relative block bg-white rounded-lg hover: lg:rounded-xl xl:rounded-2xl"
    >
      {({ isHovering }) => (
        <>
          <div className="relative z-10 p-8 rounded-lg shadow-xs">
            <div className="flex items-center justify-center mb-6 text-green-500 bg-green-100 rounded-full h-14 w-14">
              <svg
                className="relative z-10 w-8 h-auto"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                {icon}
              </svg>
            </div>
            <TertiaryTitle level={3}>{title}</TertiaryTitle>
            <Text muted className="mt-4">
              {description}
            </Text>
          </div>
          <div
            className={clsx(
              'absolute inset-0 z-0 transform rounded-lg bg-white transition duration-300 ease-in-out lg:rounded-xl xl:rounded-2xl',
              !isHovering && 'shadow-lg',
              isHovering && 'scale-105 shadow-xl'
            )}
          />
        </>
      )}
    </Link>
  );
}

SectionContactLink.defaultProps = defaultProps;
SectionContactLink.propTypes = propTypes;
